import React from 'react';

const ruRUS: React.FC = () => (
  <svg width='16' height='12' viewBox='0 0 16 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect fill='#FFFFFF' width='16' height='6' />
    <rect fill='#D52B1E' y='6' width='16' height='6' />
    <rect fill='#0039A6' y='4' width='16' height='4' />
  </svg>
);

export default ruRUS;

